import { marked } from "marked";
import DOMPurify from "dompurify";

marked.setOptions({
  gfm: true,
  breaks: true,
});

/**
 * Renders AI answer Markdown safely for the browser (no Node polyfills).
 */
const AiMarkdown = ({ children, className = "" }) => {
  const content = typeof children === "string" ? children : "";
  if (!content.trim()) return null;

  const html = DOMPurify.sanitize(marked.parse(content), {
    USE_PROFILES: { html: true },
  });

  return (
    <div
      className={`ai-markdown ${className}`.trim()}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default AiMarkdown;
